import { Component, OnInit } from '@angular/core';
import { environment } from '@tech-environments/environment';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import { faSpinner, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '@tech-services/common.service';
import { TranslateService } from '@ngx-translate/core';

import { takeUntil } from 'rxjs/operators';
import { MatButton } from '@angular/material/button';
import { Subject, timer } from 'rxjs';
import { LoginService } from '@tech-services/login.service';
import { MustMatch } from '../../core/helpers/must-match.validator';
import { AppConfig } from '@tech-utils/app-config.service';
import { TechDialogsService } from '../../shared/tech-dialogs.service';

@Component({
  selector: 'tech-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  public form: UntypedFormGroup;
  public faSpinner: IconDefinition = null;
  public logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  public resetResult: boolean;
  private unsubscribe$ = new Subject<void>();
  public hide: boolean = true;
  public hide2: boolean = true;
  private urlTree: any;
  public ta: string;
  public isWelcome: boolean = true;
  private timer3s = timer(3000);
  public passwordMinLength: boolean = false;
  public password2MinLength: boolean = false;
  public passwordpattern: boolean = false;
  public password2pattern: boolean = false;
  public noMatchPass: boolean = false;
  public textMinLengthPass;
  //Nuevas
  public errorMinLength: boolean = true;
  public errorUpcase: boolean = true;
  public errorDowncase: boolean = true;
  public errorDigi: boolean = true;
  public errorChart: boolean = true;
  public errorPasswordRepeat: boolean = true;
  public regex: string = AppConfig.settings.passRequirement;
    //'^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+,.-¬¡><])[A-Za-z\\d!@#$%^&*()_+,.-¬¡><]^[^"\'=]*$+$';
  public regexUpcase: string = '^(?=.*[A-Z])';
  public regexDowncase: string = '^(?=.*[a-z])';
  public regexDigi: string = '^(?=.*[0-9].*)';
  public regexChart: string = '^(?=.*[!@#$%^&*()_+,.><¬¡-])^[^"\'=]*$';

  constructor(
    private fb: UntypedFormBuilder,
    private loginService: LoginService,
    private router: Router,
    private commonService: CommonService,
    private translate: TranslateService,
    private dialogService: TechDialogsService
  ) {
    this.newform();
    this.urlTree = this.router.parseUrl(this.router.url);
  }

  ngOnInit() {
    this.resetResult = false;
    this.ta = this.urlTree.queryParams['ta'];
    this.isWelcome = this.urlTree.queryParams['IsWelcome'] ? true : false;

    this.form.statusChanges.subscribe((result) => this.formValidation());

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
  get f() {
    return this.form.controls;
  }

  public validateToken() {
    let text01;
    let text02;
    this.translate.get('k001977').subscribe((text: string) => {
      text01 = text;
    });
    this.translate.get('k001962').subscribe((text: string) => {
      text02 = text; //Token: Token invalido o caducado. Vuelva a solicitar el cambio de contraseña.
      this.loginService
        .validateTokenModifyPassword(this.ta)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (data) => {
            if (!data.IsValid) {
              this.dialogService.openModalDialog(
                '',
                text01, //Token: Create password
                text02, //Token: Token invalido o caducado. Vuelva a solicitar el cambio de contraseña.
                ''
              );
              //Para que redireccione cuando es producción
              if (environment.production) {
                this.timer3s.subscribe(() => {
                  this.router.navigate(['/login']);
                });
              }
            }
          },
          (err) => {

          }
        );
    });
  }

  public sendPass() {
    let text02;
    this.translate.get('k001962').subscribe((text: string) => {
      text02 = text; //Token: Token invalido o caducado. Vuelva a solicitar el cambio de contraseña.
      this.loginService
        .modifyPassword(this.ta, this.form.value.password)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          () => {
            this.resetResult = true;
          }
        );
    });
  }

  /* Nuevos funciones */
  private regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  private mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    };
  }

  newform() {
    this.form = new UntypedFormGroup(
      {
        password: new UntypedFormControl('', [
          Validators.required,
          Validators.minLength(AppConfig.settings.minLengthPass),
          this.regexValidator(new RegExp(this.regexUpcase), {
            upcase: 'error',
          }),
          this.regexValidator(new RegExp(this.regexDowncase), {
            downcase: 'error',
          }),
          this.regexValidator(new RegExp(this.regexDigi), {
            digi: 'error',
          }),
          this.regexValidator(new RegExp(this.regexChart), {
            specialchart: 'error',
          }),
        ]),
        password2: new UntypedFormControl('', [Validators.required]),
      },

      this.mustMatch('password', 'password2')
    );
  }

  public formValidation() {
    if (this.form.controls.password.errors != null) {
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.minlength != null
        ? (this.errorMinLength = true)
        : (this.errorMinLength = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.upcase != null
        ? (this.errorUpcase = true)
        : (this.errorUpcase = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.downcase != null
        ? (this.errorDowncase = true)
        : (this.errorDowncase = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.digi != null
        ? (this.errorDigi = true)
        : (this.errorDigi = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.specialchart != null
        ? (this.errorChart = true)
        : (this.errorChart = false);
    } else {
      this.errorMinLength = false;
      this.errorUpcase = false;
      this.errorDowncase = false;
      this.errorDigi = false;
      this.errorChart = false;
    }
    this.errorPasswordRepeat =
      this.form.controls.password.value === this.form.controls.password2.value
        ? false
        : true;
  }
  
  public viewHintHelp(event) {
    let text1: string;
    let text2: string;
    this.translate.get('k004086').subscribe((text: string) => {
      text1 = text; //Token: Caracteres especiales
    });
    this.translate.get('k004087').subscribe((text: string) => {
      text2 = text; //Token: Por favor, evite los siguientes caracteres: Apóstrofe ('), comillas dobles (\") y símbolo igual (=).
      this.dialogService.openModalDialog('', text1, text2, '');
    });
  }

}
